import React, { useEffect, useMemo } from 'react'
import { useGetUserProductQuery, useReactToProductMutation } from 'context/product/productApiSlice';
import DOMPurify from 'isomorphic-dompurify';
import parse from 'html-react-parser';

import { Grid } from "@mui/material";
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDBadge from 'dashboard/components/MDBadge';
import DefaultProjectCard from "dashboard/examples/Cards/ProjectCards/DefaultProjectCard";

const parseContent = content => parse(DOMPurify?.sanitize(content));

const  limitTextToWords = (text, maxWords = 100)=>{
  if(typeof text !== "string" ) return "...";
  // Split the text into an array of words
  const words = text.split(' ');

  // If the number of words is less than or equal to the limit, return the original text
  if (words.length <= maxWords) {
    return text;
  }

  // Otherwise, slice the array to get the first 'maxWords' words and join them back into a string
  const limitedText = words.slice(0, maxWords).join(' ');

  // Add an ellipsis (...) to indicate that the text has been truncated
  return limitedText + '...';
}

const Index = ({ connectedUser, showAlerts }) => {
  const [likeProduct,{ isLoading : reactLoading }] = useReactToProductMutation();
  const { id } = connectedUser;
  const {
    data : Favorite = [],
    isLoading,
    isError,
    error
  } = useGetUserProductQuery(id, {
      refetchOnMountOrArgChange: true,
      skip : id === undefined
  });

  const { productsList, totalNumProducts } = useMemo(() => {
    const { productsList = [], totalNumProducts = 0 } = Favorite;
    return { productsList, totalNumProducts };
  }, [Favorite]);

  useEffect(() => {
    /* eslint-disable-next-line */
    isError ? showAlerts({
      title : "Dashboard Alert",
      type  : "toast",
      msg :  error.data?.error,
      color :"error"
    }) : null
  }, [error, isError])

  const handleLikeProduct = async update =>{
    try{
      /*eslint-disable*/
      const ratingResponse = await likeProduct(({id:update.id, update:{user : connectedUser, product : update.id, content : update.reaction}})).unwrap();
      showAlerts({code:"success", icon:"done", title : "aimer produit",msg : ratingResponse.message, type : "toast"});
    }catch(error){
      showAlerts({code:"error", icon:"error", title : "aimer produit",msg : error.data.error, type : "toast"});
    }   
  }

  return (
    <>
      <MDBox pt={2} px={2} lineHeight={1.25}>
        <MDTypography variant="h6" fontWeight="medium">
          produits préférés <MDBadge max={totalNumProducts}  badgeContent={totalNumProducts} variant="gradient" size="xs" container color="error" />
        </MDTypography>
        <MDBox mb={1}>
          <MDTypography variant="button" color="text">
            Liste de mes produits préférés
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox p={2}>
        <Grid container spacing={6}>
          {productsList &&  productsList.map( product => (<Grid key={`${product.id}-products`} item xs={12} md={6} lg={3}>
            <DefaultProjectCard
              image={`${process.env.REACT_APP_PUBLIC_URL}/img/products/${product.selectedImage}`}
              label={product.productName}
              title={product.category?.name || "Tout"}
              description={limitTextToWords(parseContent(product.description))}
              action={[{
                type: "internal",
                route: `/product/${product.id}`,
                color: "info",
                label: "details +",
              }, {
                type: "event",
                route: `remove`,
                color: "error",
                label: "supprimer -",
                event:()=>handleLikeProduct({id: product.id, reaction : "dislike"})
              }]}
              authors={[
                // { image: team1, name: "Elena Morison" },
                // { image: team2, name: "Ryan Milly" },
                // { image: team3, name: "Nick Daniel" },
                // { image: team4, name: "Peterson" },
              ]}
            />
          </Grid>))}
        </Grid>
      </MDBox>
    </>
  )
}

export default Index